import { ObjectPropertyValue } from '../../shared/types'
import { Tooltip, TooltipWrap } from './tooltip'

export const SOURCE_COLOR: Record<string, string> = {
	rentner: 'bg-red-600',
	beskyd: 'bg-blue-900',
	borent: 'bg-sky-400',
	default: '',
}

export const SOURCE_NAME: Record<string, string> = {
	rentner: 'Rentner',
	beskyd: 'Beskyd',
	borent: 'Borent',
}

export function SourceFormatter({ source }: { source?: ObjectPropertyValue }) {
	if (!source || typeof source !== 'string') return null

	return (
		<Tooltip content={SOURCE_NAME[source]} delay={50}>
			<TooltipWrap>
				<div className="m-auto p-2">
					<div className={`${SOURCE_COLOR[source]} w-2 h-2 m-auto rounded-full`} />
				</div>
			</TooltipWrap>
		</Tooltip>
	)
}
